import { asambleaData } from '@/mocks/nosotros-data';

export default function AsambleaSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden h-[340px] md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Authentic%20institutional%20assembly%20gathering%20of%20peruvian%20musicians%20and%20artists%20in%20a%20formal%20venue%20warm%20natural%20lighting%20people%20engaged%20in%20democratic%20voting%20process%20genuine%20expressions%20cultural%20community%20meeting%20documentary%20editorial%20style%20no%20posing%20human%20connection%20Lima%20Peru&width=800&height=1000&seq=soniem-nosotros-asamblea-01&orientation=portrait"
                  alt="Asamblea General SONIEM"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary-50 rounded-2xl -z-10" />
            </div>

            {/* Content */}
            <div>
              <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
                Máximo órgano de gobierno
              </span>
              <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight mb-5">
                {asambleaData.title}
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {asambleaData.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}